import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// CMS API base query
const cmsBaseQuery = fetchBaseQuery({
  baseUrl: `${
    import.meta.env.VITE_CMS_API_URL || "http://localhost:1337"
  }/api/`,
  prepareHeaders: (headers) => {
    headers.set("Content-Type", "application/json");
    return headers;
  },
});

// CMS API slice
export const cmsApi = createApi({
  reducerPath: "cmsApi",
  baseQuery: cmsBaseQuery,
  endpoints: () => ({}),
  tagTypes: [
    "sliders",
    "notices",
    "contact",
    "footer",
    "chairperson-message",
    "board-of-directors",
    "former-bods",
    "sub-committees",
    "moa-laws",
    "affiliated-clubs",
    "alumni-association",
    "csr-welfare",
    "faq",
  ],
});

export const {} = cmsApi;
